<p-selectButton [options]="options"
                [optionLabel]="optionLabel"
                [dataKey]="dataKey"
                [styleClass]="styleClass"
                [multiple]="multiple"
                [disabled]="disabled"
                (onChange)="selectionChange($event)"
                [(ngModel)]="selectedItem"></p-selectButton>
